// eslint-disable-next-line no-unused-vars
import React from "react";
import ReactDOM from "react-dom";
import App from "./App.js";
import store from "./redux-store/store";
import { Provider } from "react-redux";
/** @jsx jsx */
import { jsx, ThemeProvider } from '@emotion/react';
import theme from './styles/theme';
const modalRoot = document.getElementById("navbar-root");
const portalProps = Object.assign({}, modalRoot?.dataset);
if (module.hot) {
    module.hot.accept();
}
ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App {...portalProps} />
        </ThemeProvider>
    </Provider>,
    document.getElementById("application")
);